<template>
  <div class="mode-title" :class="{ row: row, center: algin == 'center', left: algin == 'left' }">
    <!-- <div v-if="num" class="num-img">
      <img :src="`/static/img/num/${num}.png`">
    </div> -->
    <div class="title-content-wrap">
      <ModeTitleImg :title="title" />
    </div>
  </div>
</template>

<script>
import ModeTitleImg from './mode-title-img.vue'
export default {
  components: { ModeTitleImg },
  props: {
    title: {
      type: String,
    },
    num: {
      type: String
    },
    row: {
      type: Boolean,
      default: false
    },
    algin: {
      type: String,
      default: 'center'
    }
  },
}
</script>

<style lang="less" scoped>
.mode-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 1px 0 24px;
  font-family: xingkai;
  .num-img {
    img {
      width: 44px;
    }
  }
  &.row {
    flex-direction: row;
    justify-content: center;
    padding: 1px;
    gap: 18px;
    .num-img {
      position: relative;
    }
  }
  &.center {
    justify-content: center;
  }
  &.left {
    justify-content: flex-start;
  }
  .title-content-wrap {
    position: relative;
    top: -4px;
    &::after {
      content: "";
      position: absolute;
      right: -38px;
      bottom: -20px;
      height: 40px;
      aspect-ratio: 19 / 7;
      background: url('@/assets/image/figure/mode-title-bg.png');
      background-size: 100% 100%;
    }
    .title-img {
      height: 28px;
      img {
        height: 100%;
      }
    }
    .title-inner-text {
      font-size: 26px;
      color: @themeColor2;
      letter-spacing: 1px;
    }
  }
}
@media screen and (max-width: @xsW) {
  
}
</style>
